<template>
  <el-table-column
    prop="stowage.receipt_number"
    sortable="custom"
    label="Kapcsolódó rakodási lista"
    show-overflow-tooltip
    min-width="220"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.stowage_receipt_number"
        style="display: inline-block;"
      >
        <receipt-link
            :id="scope.row.id"
            :label="scope.row.stowage_receipt_number"
            type="stowage"
        />
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó rakodási lista</el-tag>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  propName: 'stowage.receipt_number',
};
</script>

